import { render } from "./UnsubscribeGame.vue?vue&type=template&id=79f3c1b6&scoped=true"
import script from "./UnsubscribeGame.vue?vue&type=script&lang=js"
export * from "./UnsubscribeGame.vue?vue&type=script&lang=js"

import "./UnsubscribeGame.vue?vue&type=style&index=0&id=79f3c1b6&lang=css"
import "./UnsubscribeGame.vue?vue&type=style&index=1&id=79f3c1b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f3c1b6"]])

export default __exports__